module.exports = __webpack_public_path__ + "c6f497c33ec46d1ef5a6bb12741f61ad.png";